export const Pie_Chart_Data: Highcharts.Options = {
  chart: {
    backgroundColor: 'rgba(30, 34, 37, 0.04)',
    plotBorderWidth: undefined,
    plotShadow: false,
    type: 'pie',
    width: 200,
    height: 130,
    margin: 0,
    marginRight: 105,
  },
  title: {
    text: '',
  },
  tooltip: {
    pointFormat: ': <b>{point.percentage:.1f}%</b>',
    headerFormat: '{point.key}',
    style: {
      fontSize: '10px',
    },
  },
  accessibility: {
    point: {},
  },
  plotOptions: {
    pie: {
      cursor: 'pointer',
      dataLabels: {
        enabled: false,
      },
      showInLegend: true,
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    layout: 'vertical',
    align: 'right',
    verticalAlign: 'middle',
    labelFormat: '{name} {y:.0f}%',
    x: 5,
    y: 0,
    itemStyle: {
      fontSize: '5px',
      fontWeight: 'normal',
    },
    itemMarginTop: 2,
    itemMarginBottom: 2,
    itemDistance: 8,
    symbolHeight: 6,
    symbolWidth: 6,
    symbolRadius: 3,
    useHTML: true,
    maxHeight: 120,
  },
  series: [
    {
      name: 'Pie',
      type: 'pie',
      data: [],
    },
  ],
};
